/*@ngInject*/
const ActivityStreamRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActivityStreamItems = function (submissionId) {
        let url = '/rest/ActivityEvent',
            config = {
                params: {
                    submissionId: submissionId,
                    showViewed: true,
                    startIndex: 0,
                    numberOfRows: -1
                }
            };

        return this.get(url, config);
    };

    this.processGetResponseData = function (responseData) {
        _.each(responseData, function (streamItem) {
            streamItem.actorAvatar = streamItem.actorAvatar || '';
            streamItem.note = xmlUtil.parseString(streamItem.note);
        });

        return responseData;
    };
};

angular.module('gw-um-submission')
    .service('activityStreamRepository', ActivityStreamRepository);
